export const updateChat = (token: string) => {
    window.fcWidget.conversation.setBotVariables({
        tempToken: token,
    });
};
